module.exports = __webpack_public_path__ + "static/media/sub-shield.6f75ec5f.svg";